import { createAction } from 'redux-actions';
import * as constants from 'constants/redux/cottage';

export const clearCottage = createAction(constants.CLEAR_COTTAGE);

export const fetchCottageRequest = createAction(constants.FETCH_COTTAGE_REQUEST);
export const fetchCottageSuccess = createAction(constants.FETCH_COTTAGE_SUCCESS);
export const fetchCottageFailure = createAction(constants.FETCH_COTTAGE_FAILURE);

export const createCottageRequest = createAction(constants.CREATE_COTTAGE_REQUEST);
export const updateCottageRequest = createAction(constants.UPDATE_COTTAGE_REQUEST);
export const updateCottageSuccess = createAction(constants.UPDATE_COTTAGE_SUCCESS);
export const updateCottageFailure = createAction(constants.UPDATE_COTTAGE_FAILURE);
export const updateCottageIdle = createAction(constants.UPDATE_COTTAGE_IDLE);

export const removeCottageRequest = createAction(constants.REMOVE_COTTAGE_REQUEST);
export const removeCottageSuccess = createAction(constants.REMOVE_COTTAGE_SUCCESS);
export const removeCottageFailure = createAction(constants.REMOVE_COTTAGE_FAILURE);

export const lastMinuteDealsRequest = createAction(constants.LAST_MINUTE_DEALS_REQUEST);
export const lastMinuteDealsSuccess = createAction(constants.LAST_MINUTE_DEALS_SUCCESS);
export const lastMinuteDealsFailure = createAction(constants.LAST_MINUTE_DEALS_FAILURE);
export const lastMinuteDealsDelete = createAction(constants.LAST_MINUTE_DEALS_DELETE);
export const lastMinuteDealsDeleteSuccess = createAction(constants.LAST_MINUTE_DEALS_DELETE_SUCCESS);
export const lastMinuteDealsCreate = createAction(constants.LAST_MINUTE_DEALS_CREATE);
export const lastMinuteDealsCreateSuccess = createAction(constants.LAST_MINUTE_DEALS_CREATE_SUCCESS);

export const cottageVerification = createAction(constants.COTTAGE_VERIFICATION_REQUEST);
export const changeCottagePristine = createAction(constants.CHANGE_COTTAGE_PRISTINE);
export const fetchCottagesTagsRequest = createAction(constants.FETCH_COTTAGES_TAGS_REQUEST);
export const fetchCottagesTagsSuccess = createAction(constants.FETCH_COTTAGES_TAGS_SUCCESS);
